"use client";

import type { ReactNode } from "react";
import Link from "next/link";
import { PRIMARY_DEMO_JOB_ID } from "../constants";
import { track } from "../lib/track";

export function HeroDemoLink({
  children,
  source = "hero screenshot",
  className = "",
}: {
  children: ReactNode;
  source?: string;
  className?: string;
}) {
  return (
    <Link
      className={className || "lp-hero-visual"}
      href={`/s/${PRIMARY_DEMO_JOB_ID}`}
      aria-label="See the example website audit report"
      onClick={() => track("Demo Opened", { site: "Figma", source })}
    >
      {children}
    </Link>
  );
}
